import { render } from "./currency-dropdown.vue?vue&type=template&id=72f35248"
import script from "./currency-dropdown.vue?vue&type=script&lang=js"
export * from "./currency-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__